export const COMPARISON_PAGE_PATH = '/nutrition-software-comparison';
export const COMPARISON_HEADING = 'CalorieScience vs traditional nutrition software';
export const COMPARISON_PAGE_TITLE = 'Nutrition Software Comparison | CalorieScience';
export const COMPARISON_DESCRIPTION = 'Compare CalorieScience with nutrition analysis software and practice-management platforms across meal planning, blood biomarkers, medication alerts and data hosting.';
export const COMPARISON_INTRO = 'Most nutrition software was built either for nutrient analysis and menu output, or for practice admin such as scheduling and billing. CalorieScience is built for one-to-one personalisation grounded in biomarker data.';
export const COMPARISON_CONCLUSION = 'You can still do core nutrient analysis in CalorieScience. The difference is that the analysis connects directly to the plan.';

export const COMPARISON_ROWS = [
  {
    label: "Core focus",
    traditional: "Nutrient calculation, menu output",
    practice: "Scheduling, billing, client records",
    cs: "Biomarker-informed personalised care",
  },
  {
    label: "Meal plans",
    traditional: "Template-based",
    practice: "Built manually by the practitioner",
    cs: "AI-drafted from client data, practitioner-approved",
  },
  {
    label: "Blood biomarkers",
    traditional: "Not typically included",
    practice: "Stored as records or attachments",
    cs: "Analysed and flagged, linked to meal planning",
  },
  {
    label: "Drug–nutrient alerts",
    traditional: "Not typically included",
    practice: "Not typically included",
    cs: "Built in",
  },
  {
    label: "AI-assisted interpretation",
    traditional: "No",
    practice: "Limited",
    cs: "Yes, with full practitioner override",
  },
  {
    label: "Data hosting",
    traditional: "Varies",
    practice: "Varies",
    cs: "EU (Frankfurt), UK and EU GDPR compliant",
  },
];
